import { Typography } from '@euler/app/components/typography';
import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { BottomPanel } from '@euler/components/BottomPanel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { kBiMaxDashboardName } from '@euler/model/bi/dashboard';
import { memo, useEffect, useState } from 'react';
import { TextInput, View } from 'react-native';
import { BiButton } from './ui/BiButton';

/** Asks for a dashboard name: creating one, or renaming it. */
export const BiNamePanel = memo(
  ({
    visible,
    title,
    initialName,
    confirmTitle,
    error,
    busy,
    onConfirm,
    onClose,
  }: {
    visible: boolean;
    title: string;
    initialName: string;
    confirmTitle: string;
    /** Why the last attempt failed, shown in place. */
    error: string | null;
    busy: boolean;
    onConfirm: (name: string) => void;
    onClose: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    const [name, setName] = useState(initialName);
    useEffect(() => {
      if (visible) setName(initialName);
    }, [visible, initialName]);
    const trimmed = name.trim();
    const submit = () => {
      if (trimmed && !busy) onConfirm(trimmed);
    };
    return (
      <BottomPanel visible={visible} onClose={onClose} fitContent>
        <View style={{ padding: rpx(24), gap: rpx(12) }}>
          <Typography.Text medium size={rpx(15)} color={aiColors.foreground}>
            {title}
          </Typography.Text>
          <TextInput
            accessibilityLabel="看板名称"
            value={name}
            onChangeText={setName}
            onSubmitEditing={submit}
            maxLength={kBiMaxDashboardName}
            placeholder="例如：门店经营周报"
            placeholderTextColor={aiColors.mutedForeground}
            autoFocus
            returnKeyType="done"
            style={{
              height: rpx(40),
              paddingHorizontal: rpx(12),
              borderRadius: rpx(10),
              borderWidth: 1,
              borderColor: aiColors.border,
              backgroundColor: aiColors.input,
              color: aiColors.foreground,
              fontSize: rpx(14),
            }}
          />
          {error ? (
            <Typography.Text size={rpx(12)} color={aiColors.destructive}>
              {error}
            </Typography.Text>
          ) : null}
          <View
            style={{
              flexDirection: 'row',
              justifyContent: 'flex-end',
              gap: rpx(8),
            }}
          >
            <BiButton title="取消" onPress={onClose} />
            <BiButton
              title={confirmTitle}
              tone="primary"
              loading={busy}
              disabled={!trimmed}
              onPress={submit}
            />
          </View>
        </View>
      </BottomPanel>
    );
  },
);
